import { PiSquaresFour, PiArrowRight } from "react-icons/pi";

const HighlightMetricCard = ({ value, label, subtitle, bgColor = "bg-[#D2873E]" }) => {
  return (
    <div className={`${bgColor} rounded-lg p-10 shadow-sm relative text-white min-h-[400px] flex flex-col justify-between`}>
      <div className="flex items-start gap-6 pt-8">
        <div className="bg-white rounded-2xl p-5 flex items-center justify-center flex-shrink-0">
          <PiSquaresFour className="w-10 h-10 text-[#D2873E]" />
        </div>
        <div>
          <div className="text-6xl font-bold mb-2">{value}</div>
          <div className="text-xl">{label}</div>
        </div>
      </div>
      
      <div className="border-t border-white border-opacity-40 border-dotted pt-6 mt-auto">
        <div className="flex items-center justify-between">
          <p className="text-lg">{subtitle}</p>
          <button className="text-white hover:text-gray-100">
            <PiArrowRight className="w-7 h-7" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default HighlightMetricCard;
